import { BaseService } from "src/services/baseService";
import { ActiveAntsReceivingDiscrepancyAPIService } from "./activeAntsReceivingDiscrepancyAPIService";
import { sanitiseParams } from "src/utils/sanitiser";
import { ReceivingDiscrepancy, IssueStatus } from "src/types";

class ActiveAntsReceivingDiscrepancyService extends BaseService<ActiveAntsReceivingDiscrepancyAPIService> {
  @sanitiseParams()
  async getActiveAntsReceivingDiscrepancy(
    activeAntsPurchaseOrderId: string,
    receivingDiscrepancyStatus?: IssueStatus
  ): Promise<ReceivingDiscrepancy | undefined> {
    return await this.apiService.getActiveAntsReceivingDiscrepancyById(activeAntsPurchaseOrderId, {
      receivingDiscrepancyStatus
    });
  }

  @sanitiseParams()
  async resolveActiveAntsReceivingDiscrepancy(
    activeAntsPurchaseOrderId: string,
    resolutionDetails: string
  ): Promise<ReceivingDiscrepancy | undefined> {
    return await this.apiService.patchActiveAntsReceivingDiscrepancyResolution(activeAntsPurchaseOrderId, {
      resolutionDetails
    });
  }
}

export { ActiveAntsReceivingDiscrepancyService };
